/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Photo_ReplaceInputs */

const en_history_photo_replace = /** @type {(inputs: History_Photo_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace photo`)
};

const de_history_photo_replace = /** @type {(inputs: History_Photo_ReplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anderes Foto`)
};

/**
* | output |
* | --- |
* | "Replace photo" |
*
* @param {History_Photo_ReplaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_photo_replace = /** @type {((inputs?: History_Photo_ReplaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Photo_ReplaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_photo_replace(inputs)
	return en_history_photo_replace(inputs)
});